module.exports = __webpack_public_path__ + "img/canbadge_daishi_60_70mm.7d50c2de.png";